{
	"title": "Projekty",
	"table": {
		"reference": "Odkaz",
		"quantity": "Celkové množství",
		"savings": "Celkové snížení uhlíku",
		"fetchError": "Projekty se nepodařilo načíst"
	},
	"showProjectsHistoryTitle": "Zobrazit historii projektů",
	"noProjects": {
		"createDeclaration": "Vytvořte své první prohlášení",
		"description": "Kliknutím na „Vytvořit prohlášení“ můžete vytvořit prohlášení pro jeden nebo více materiálů."
	}
}
